import cn from "classnames";
import classNames from "classnames";
import { CSSProperties } from "react";

import Icon from "~/components/common/icon";
import Editorials from "~/types/editorials";

import styles from "./loyalty-blocks.module.scss";

type Props = {
  blocks: Editorials.LoyaltyBlocksModel[];
  isBackgroundGradient?: boolean;
};

export default function LoyaltyBlocks(props: Props) {
  const { blocks, isBackgroundGradient } = props;
  const styleSteps = { "--number-blocks": blocks.length } as CSSProperties;

  return (
    <div style={styleSteps} className={styles.container}>
      <LoyaltyBlocksMobile
        blocks={blocks}
        isBackgroundGradient={isBackgroundGradient}
        classNames={styles.mobileOnly}
      />
      <LoyaltyBlocksDesktop
        blocks={blocks}
        isBackgroundGradient={isBackgroundGradient}
        classNames={styles.desktopOnly}
      />
    </div>
  );
}

function LoyaltyBlocksMobile(props: Props & { classNames?: string }) {
  const { blocks, isBackgroundGradient, classNames } = props;

  return blocks.map((block, index) => {
    const { title, description, iconId, tag } = block;
    return (
      <div
        key={index}
        className={cn(
          styles.cardMobile,
          classNames,
          isBackgroundGradient ? styles.removeBorder : undefined,
        )}
      >
        {iconId && (
          <div className={cn(styles.wrapperIcon, styles.backgroundGradient)}>
            <Icon name={iconId} width={48} height={48} />
          </div>
        )}
        <div className={styles.bodyCardMobile}>
          <p className={styles.title}>{title}</p>
          {description && <p className={styles.description}>{description}</p>}
          {tag && <p className={styles.tag}>{tag}</p>}
        </div>
      </div>
    );
  });
}

function LoyaltyBlocksDesktop(props: Props & { classNames?: string }) {
  const { blocks, isBackgroundGradient, classNames } = props;

  return blocks.map((block, index) => {
    const { title, description, iconId, tag } = block;
    return (
      <div
        key={index}
        className={cn(
          styles.card,
          classNames,
          isBackgroundGradient ? styles.removeBorder : undefined,
        )}
      >
        <div
          className={cn(
            styles.headingCard,

            isBackgroundGradient ? styles.backgroundWhite : undefined,
          )}
        >
          {iconId && (
            <div
              className={cn(
                styles.wrapperIcon,
                isBackgroundGradient ? styles.backgroundGradient : undefined,
              )}
            >
              <Icon name={iconId} width={48} height={48} />
            </div>
          )}
          <p className={styles.title}>{title}</p>
        </div>
        <div className={styles.bodyCard}>
          {description && <p className={styles.description}>{description}</p>}
          {tag && <p className={styles.tag}>{tag}</p>}
        </div>
      </div>
    );
  });
}
